import React from "react";

// Components
import AddLead from "./AddLead";
import Overlay from "shared/components/overlay/Overlay";
import SlidingPanel from "shared/components/sliding-panel/SlidingPanel";


// Styles
import styles from './AddLead.module.scss';


const AddLeadPanel = ({ isActive=false, onAddNewLead, onClose, withStage = false }) => {
    return (
        <div className={ styles.wrapper }>
            <SlidingPanel className={ styles.panel } isActive={ isActive }>
                { isActive && <AddLead
                    onClose={ onClose }
                    withStage={ withStage }
                    onAddNewLead={ onAddNewLead } />
                }
            </SlidingPanel>

            <Overlay
                className={ styles.overlay }
                isActive={ isActive }
                isContained
                onClick={ onClose } />
        </div>
    )
}

export default AddLeadPanel;
